import React, { Component } from 'react';
import { Input, FormGroup, Label } from 'reactstrap';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { connect } from 'react-redux';
import { fetchSubscriptions, addSubscription, updateSubscription, fetchSubscriptionPackages } from '../../../../../../../Redux/Actions/Admin/ManageSubscriptionActions';
import { fetchSubscriptionTypes, selectSubscriptionType } from '../../../../../../../Redux/Actions/Admin/ManageSubscriptionTypeActions';
import { fetchSubscriptionStatuses, selectSubscriptionStatus } from '../../../../../../../Redux/Actions/Admin/ManageSubscriptionStatusActions';
import { fetchStates } from '../../../../../../../Redux/Actions/CommonActions';
import '../../../ManageSubscriptions/ManageSubscriptions.scss';
import {
    addToPurchase,
    updatePurchase,
    changeView,
    setAlert
} from '../../../../../../../Redux/Actions/Admin/ManagePurchaseAndRenewalsActions';

import IsLoading from '../../../../../../Shared/Loading/IsLoading';
import { Alert } from 'reactstrap';

import axios from 'axios';
import { ROOT_API_URL } from '../../../../../../../api-config';
import _ from 'lodash';
import { auth } from '../../../../../../../services';

const initialState = {
    firstRender: false,
    subscriptionInEdit: {},
    value: [],
    selectedSubscription: null,
    subscriptionData: [],
    subscriptionLookupEmail: "",
    view: "RenewSubscription",
    total: "",
    id: 0,
    UserId: "",
    Name: "",
    ActualCost: "",
    SuggestedCost: 0,
    companyName: "",
    preferredMailingName: "",
    firstName: "",
    lastName: "",
    email: "",
    mailingAddress1: "",
    mailingAddress2: "",
    mailingCity: "",
    mailingZip: "",
    stateId: "",
    phone: "",
    concatinatedMagString: "",
    touched: {
        firstName: false,
        lastName: false,
        companyName: false,
        preferredMailingName: false,
        mailingAddress1: false,
        mailingCity: false,
        mailingZip: false,
        phone: false,
        email: false,
    },
    isLoading: false
};

class RenewSubscription extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;

        this.delayedCallback = _.debounce(this.checkEmailCall, 1000);
        this.onEmailChange = this.onEmailChange.bind(this);
    }

    componentDidMount() {
        this.props.fetchSubscriptionPackages();
        this.props.fetchStates();
        if (this.props.purchaseAndRenewals.editingPurchase) {
            this.setState({
                ...this.props.purchaseAndRenewals.editingPurchase
            })
        }

        if (this.props.purchaseAndRenewals.userInfo) {
            this.setState(
                {
                    firstRender: true,
                    subscriptionLookupEmail: this.props.purchaseAndRenewals.userInfo.email || this.props.purchaseAndRenewals.userInfo.lastName
                }, () => {
                    this.checkEmailCall();
                }
            );
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.purchaseAndRenewals.editingPurchase !== this.props.purchaseAndRenewals.editingPurchase) {
            this.setState({
                ...this.props.purchaseAndRenewals.editingPurchase
            })
        }
    }


    checkEmailCall() {
        this.setState({ isLoading: true })
            
        const options = { params: { searchTerm: this.state.subscriptionLookupEmail }, method: 'GET', headers: auth.authHeader() };
        axios.get(`${ROOT_API_URL}/ManageTransaction/SearchSubscription`, options).then(
            (response) => {
                if (response.data.length > 0) {
                    this.setState({
                        subscriptionData: response.data,
                        isLoading: false
                    }, 
                        () => this.props.setAlert(true, "Users Found", 'success')
                    );

                    if (this.state.firstRender && response.data.length == 1) {
                        const resData = response.data[0];

                        this.setState({
                            selectedSubscription: resData,
                            total: resData.actualCost,
                            id: 0,
                            IsRenewal: true,
                            companyName: resData.companyName,
                            MagazineSubscriptionPackage: resData.magazineSubscriptionPackage,
                            MagazineSubscriptionId: resData.magazineSubscriptionId,
                            UserId: resData.userID,
                            Name: resData.preferredMailingName,
                            ActualCost: resData.actualCost,
                            preferredMailingName: resData.preferredMailingName,
                            firstName: resData.firstName,
                            lastName: resData.lastName,
                            fullName: resData.fullName,
                            email: resData.email,
                            mailingAddress1: resData.mailingAddress1,
                            mailingAddress2: resData.mailingAddress2,
                            mailingCity: resData.mailingCity,
                            mailingZip: resData.mailingZip,
                            state: resData.state,
                            phone: resData.phone,
                            startDate: new Date(resData.startDate),
                            ExpireDate: new Date(resData.expireDate),
                            concatinatedMagString: resData.concatinatedMagString
                        });
                    }

                    this.setState({
                        firstRender: false
                    });

                    setTimeout(() => {
                        this.props.setAlert(false, "");
                    }, 5000)
                } else if (response.data.length === 0) {
                    this.setState({
                        ...initialState,
                        subscriptionLookupEmail: this.state.subscriptionLookupEmail,
                        isLoading: false,
                    },
                        () => this.props.setAlert(true, "No Users Found", 'danger')
                    );
                    setTimeout(() => {
                        this.props.setAlert(false, "");
                    }, 5000)
                } else {
                    this.setState({
                        ...initialState,
                        isLoading: false,
                        subscriptionLookupEmail: this.state.subscriptionLookupEmail
                    },
                        () => this.props.setAlert(true, response.data.message, 'danger')
                    );
                    setTimeout(() => {
                        this.props.setAlert(false, "");
                    }, 5000)
                }
            }).catch((response) => {
                this.setState({
                    isLoading: false
                },
                    () => this.props.setAlert(true, response.message, 'danger')
                )
            });
    }

    onEmailChange = (event) => {
        var userId = '';
        if (auth.isAuthenticated()) {
            userId = auth.getAuthUserId()
        }
        this.setState(
            {
                subscriptionLookupEmail: event.target.value,
                userID: userId
            },
            () => {
                this.delayedCallback();
            }

        );
    };

    onDialogInputChange = (event) => {
        let target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.props ? target.props.name : target.name;

        const edited = this.state;
        edited[name] = value;
        edited.isActive = true;
        this.setState({
            ...edited
        });
    };

    handleSubscriptionSelectChange = (event) => {
        if (event.target.value !== null) {
            this.setState({
                selectedSubscription: event.target.value,
                total: event.target.value.actualCost,
                id: 0,
                IsRenewal: true,
                companyName: event.target.value.companyName,
                MagazineSubscriptionPackage: event.target.value.magazineSubscriptionPackage,
                MagazineSubscriptionId: event.target.value.magazineSubscriptionId,
                UserId: event.target.value.userID,
                Name: event.target.value.preferredMailingName,
                ActualCost: event.target.value.actualCost,
                preferredMailingName: event.target.value.preferredMailingName,
                firstName: event.target.value.firstName,
                lastName: event.target.value.lastName,
                fullName: event.target.value.fullName,
                email: event.target.value.email,
                mailingAddress1: event.target.value.mailingAddress1,
                mailingAddress2: event.target.value.mailingAddress2,
                mailingCity: event.target.value.mailingCity,
                mailingZip: event.target.value.mailingZip,
                state: event.target.value.state,
                phone: event.target.value.phone,
                startDate: new Date(event.target.value.startDate),
                ExpireDate: new Date(event.target.value.expireDate),
                concatinatedMagString: event.target.concatinatedMagString
            });
        }
    }

    handleSubscriptionTypeChange = (event) => {
        if (event.target.value !== null) {
            this.setState({ MagazineSubscriptionPackage: event.target.value });
        }
    }

    formatPhone = (val) => {
        if (!val) return val;
        var x = val.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    }

    setAllTouchedTrue() {
        this.setState({
            touched: {
                firstName: true,
                lastName: true,
                companyName: true,
                preferredMailingName: true,
                mailingAddress1: true,
                mailingCity: true,
                mailingZip: true,
                phone: true,
                email: true,
            }
        })
    }

    handleBlur = (field) => (evt) => {
        this.setState({
            touched: { ...this.state.touched, [field]: true },
        });
    }

    isModelValid() {
        return this.state.firstName !== "" &&
            this.state.lastName !== "" &&
            this.state.companyName !== "" &&
            this.state.preferredMailingName !== "" &&
            this.state.mailingAddress1 !== "" &&
            this.state.mailingCity !== "" &&
            this.state.mailingZip !== "" &&
            this.state.email !== "" &&
            this.state.phone !== "";
    }

    handleSubmit = (event) => {
        event.preventDefault();
        if (this.isModelValid()) {
            event.preventDefault();
            const newState = Object.assign({}, this.state);
            newState.ActualCost = this.state.MagazineSubscriptionPackage.cost;
            newState.SuggestedCost = Number(this.state.MagazineSubscriptionPackage.cost);

            newState.Name = newState.firstName + " " + newState.lastName;
            this.setState(newState);
            if (this.props.purchaseAndRenewals.editingPurchase.MagazineSubscriptionPackage) {
                this.props.updatePurchase(newState);
            } else {
                this.props.addToPurchase(newState);
            }
            this.props.changeView({ view: "AddItems" })
        } else {
            this.setAllTouchedTrue();
        }
    };


    handleState = (event) => {
        const value = event.target.value;
        if (value !== null) {
            this.setState({ state: value });
        }
    };

    handlePhoneChange = (event) => {
        var newPhone = this.formatPhone(event.target.value);
        this.setState({
            [event.target.name]: newPhone
        });
    }


    handleStartDateChange = date => {
        this.setState({
            startDate: date
        });
    };

    handleEndDateChange = date => {
        this.setState({
            ExpireDate: date
        });
    };

    render() {
        return (
            <div>
				<Alert
					color={this.props.purchaseAndRenewals.color}
					isOpen={this.props.purchaseAndRenewals.visible}
                    style={{ position: 'fixed', width: '100%', height: '50px', zIndex: '1', top: '2px', left: '0' }}
				>
					{this.props.purchaseAndRenewals.message}
				</Alert>
                <div className="row">
                    <div className="col-md-12">
                        <label htmlFor="exampleEmail" className="label-header">Subscription Lookup: </label>
                        <Input type="email" name="subscriptionLookupEmail" id="subscriptionLookupEmail" value={this.state.subscriptionLookupEmail}
                            onChange={this.onEmailChange}
                            placeholder="Please enter member email, subscription ID or name." />
                    </div>
                </div>
                {this.state.subscriptionData.length > 0 ? 
                    <div className="row">
                        <div className="form-group col-md-12">
                            <label htmlFor="subscriptionId">Please Select User</label>
                            <DropDownList data={this.state.subscriptionData}
                                textField="concatinatedMagString"
                                dataItemKey="membershipId"
                                onChange={this.handleSubscriptionSelectChange}
                                value={this.state.selectedSubscription}
                                allowCustom={false}
                                filterable={false}
                                clearButton={false}
                                width={300}
                                required={true}
                            />
                        </div>
                    </div> : ""
                }
                <div>
                    {
                        this.state.isLoading ? (
                            <IsLoading message="Loading User Information" />
                        ) : (
                                <form className="user-form" onSubmit={this.handleSubmit}>
                                    {(this.props.purchaseAndRenewals.editingPurchase.subscriptionStartDate && this.props.purchaseAndRenewals.editingPurchase.view === "RenewSubscription") || this.state.selectedSubscription ?
                                        <div>
                                            <div className="row">
                                                <div className="form-group col-md-12">
                                                    <label htmlFor="subscriptionId">Subscription Type</label>
                                                    <DropDownList data={this.props.adminSubscription.subscriptionPackages}
                                                        textField="description"
                                                        dataItemKey="id"
                                                        onChange={this.handleSubscriptionTypeChange}
                                                        value={this.state.MagazineSubscriptionPackage}
                                                        allowCustom={false}
                                                        filterable={false}
                                                        clearButton={false}
                                                        width={300}
                                                        required={true}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="subscriptionStartDate">Subscription Start Date</label>
                                                    <DatePicker
                                                        selected={this.state.startDate}
                                                        onChange={this.handleStartDateChange} s
                                                    />
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="subscriptionExpiresDate">Subscription Expiration Date</label>
                                                    <DatePicker
                                                        selected={this.state.ExpireDate}
                                                        onChange={this.handleEndDateChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="firstName">First Name</label>
                                                    <Input
                                                        type="text"
                                                        name="firstName"
                                                        id="firstName"
                                                        value={this.state.firstName || ''}
                                                        onChange={this.onDialogInputChange}
                                                        invalid={this.state.touched.firstName && this.state.firstName === '' ? true : false}
                                                        onBlur={this.handleBlur('firstName')}
                                                    />
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="lastName">Last Name</label>
                                                    <Input
                                                        type="text"
                                                        name="lastName"
                                                        id="lastName"
                                                        value={this.state.lastName || ''}
                                                        onChange={this.onDialogInputChange}
                                                        invalid={this.state.touched.lastName && this.state.lastName === '' ? true : false}
                                                        onBlur={this.handleBlur('lastName')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="companyName">Company Name</label>
                                                    <Input
                                                        type="text"
                                                        name="companyName"
                                                        id="companyName"
                                                        value={this.state.companyName || ''}
                                                        onChange={this.onDialogInputChange}
                                                        invalid={this.state.touched.companyName && this.state.companyName === '' ? true : false}
                                                        onBlur={this.handleBlur('companyName')}
                                                    />
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="preferredMailingName">Preferred Mailing Name</label>
                                                    <Input
                                                        type="text"
                                                        name="preferredMailingName"
                                                        id="preferredMailingName"
                                                        value={this.state.preferredMailingName || ''}
                                                        onChange={this.onDialogInputChange}
                                                        invalid={this.state.touched.preferredMailingName && this.state.preferredMailingName === '' ? true : false}
                                                        onBlur={this.handleBlur('preferredMailingName')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="mailingAddress1">Address 1</label>
                                                    <Input
                                                        type="text"
                                                        name="mailingAddress1"
                                                        id="mailingAddress1"
                                                        value={this.state.mailingAddress1 || ''}
                                                        onChange={this.onDialogInputChange}
                                                        invalid={this.state.touched.mailingAddress1 && this.state.mailingAddress1 === '' ? true : false}
                                                        onBlur={this.handleBlur('mailingAddress1')}
                                                    />
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="mailingAddress2">Address 2</label>
                                                    <Input
                                                        type="text"
                                                        name="mailingAddress2"
                                                        id="mailingAddress2"
                                                        value={this.state.mailingAddress2 || ''}
                                                        onChange={this.onDialogInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group col-md-4">
                                                    <label htmlFor="mailingCity">City</label>
                                                    <Input
                                                        type="text"
                                                        name="mailingCity"
                                                        id="mailingCity"
                                                        value={this.state.mailingCity || ''}
                                                        onChange={this.onDialogInputChange}
                                                        invalid={this.state.touched.mailingCity && this.state.mailingCity === '' ? true : false}
                                                        onBlur={this.handleBlur('mailingCity')}
                                                    />
                                                </div>
                                                <div className="form-group col-md-4">
                                                    <label htmlFor="State" className="">State </label>
                                                    <DropDownList data={this.props.common.states}
                                                        dataItemKey="id"
                                                        textField="name"
                                                        onChange={this.handleState}
                                                        value={this.state.state}
                                                        allowCustom={false}
                                                        filterable={false}
                                                        clearButton={false}
                                                        width={300}
                                                        required={true}
                                                        name="State"
                                                        id="State"
                                                    />
                                                </div>
                                                <div className="form-group col-md-4">
                                                    <label htmlFor="mailingZip">Zip</label>
                                                    <Input
                                                        type="text"
                                                        name="mailingZip"
                                                        id="mailingZip"
                                                        pattern="(\d{5}([\-]\d{4})?)"
                                                        placeholder="12345"
                                                        value={this.state.mailingZip || ''}
                                                        onChange={this.onDialogInputChange}
                                                        invalid={this.state.touched.mailingZip && this.state.mailingZip === '' ? true : false}
                                                        onBlur={this.handleBlur('mailingZip')}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="email">Email</label>
                                                    <Input
                                                        type="text"
                                                        name="email"
                                                        id="email"
                                                        value={this.state.email || ''}
                                                        onChange={this.onDialogInputChange}
                                                        invalid={this.state.touched.email && this.state.email === '' ? true : false}
                                                        onBlur={this.handleBlur('email')}
                                                    />
                                                </div>
                                                <div className="form-group col-md-6">
                                                    <label htmlFor="phone">Phone</label>
                                                    <Input
                                                        type="text"
                                                        name="phone"
                                                        id="phone"
                                                        value={this.state.phone || ''}
                                                        onChange={this.handlePhoneChange}
                                                        pattern="[\(]\d{3}[\)] \d{3}[\-]\d{4}"
                                                        title="Phone Number (Format: (123) 456-7890)"
                                                        placeholder="(123) 456-7890"
                                                        invalid={this.state.touched.phone && this.state.phone === '' ? true : false}
                                                        onBlur={this.handleBlur('phone')}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        : ""}
                                    <div className="footer">
                                        <div className="form-group">

                                            {(this.props.purchaseAndRenewals.editingPurchase.subscriptionStartDate && this.props.purchaseAndRenewals.editingPurchase.view === "RenewSubscription") || this.state.selectedSubscription ?
                                                <button type="submit" className="admin-k-button">
                                                    <i className="fas fa-save"></i>
                                                    <span>SAVE</span>
                                                </button>
                                                : ""}
                                            <button className="admin-k-button" onClick={() => this.props.changeView({ view: "AddItems" })}>
                                                <i className="fas fa-times"></i>
                                                <span>CANCEL</span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            )
                    }
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        subscription: state.adminSubscription,
        common: state.common,
        subscriptionType: state.subscriptionType,
        subscriptionStatus: state.subscriptionStatus,
        adminSubscription: state.adminSubscription,
        purchaseAndRenewals: state.purchaseAndRenewals
    };
}

export default connect(mapStateToProps, {
    fetchStates,
    fetchSubscriptionStatuses,
    selectSubscriptionStatus,
    fetchSubscriptionTypes,
    selectSubscriptionType,
    fetchSubscriptionPackages,
    fetchSubscriptions,
    addSubscription,
    updateSubscription,
    addToPurchase,
    updatePurchase,
    changeView,
    setAlert
})(RenewSubscription);